export const state = () => ({
  pendingAcceptances: [],
  teamPending: [],
  applied: [],
  salesmen: [],
  isLoading: false,
})

export const mutations = {
  UPDATE_ROOT: (state, payload) => Object.assign(state, payload),
}

export const actions = {
  async fetchPendingAcceptances({ commit }) {
    if (!navigator.onLine) return
    try {
      const { data } = await this.$axios.get(
        '/v3/app/annualfeedback/pending-acceptance'
      )
      commit('UPDATE_ROOT', { pendingAcceptances: data || [] })
    } catch (e) {
      console.error(e)
    }
  },
  async fetchTeamPending({ commit }) {
    if (!navigator.onLine) return
    try {
      const { data } = await this.$axios.get(
        '/v3/app/annualfeedback/team-pending'
      )
      commit('UPDATE_ROOT', { teamPending: data || [] })
    } catch (e) {
      console.error(e)
    }
  },
  async markViewed() {
    try {
      await this.$axios.post('/v3/app/annualfeedback/viewed')
    } catch (e) {
      console.error(e)
    }
  },
  async fetchApplied({ commit }) {
    commit('UPDATE_ROOT', { isLoading: true })
    try {
      const { data } = await this.$axios.get('/v3/app/annualfeedback')
      commit('UPDATE_ROOT', { applied: data || [] })
    } finally {
      commit('UPDATE_ROOT', { isLoading: false })
    }
  },
  async fetchSalesmen({ commit }) {
    const { data } = await this.$axios.get('/v3/app/annualfeedback/salesmen')
    commit('UPDATE_ROOT', { salesmen: data || [] })
  },
  async create({ dispatch }, payload) {
    await this.$axios.post('/v3/app/annualfeedback', payload)
    await dispatch('fetchApplied')
  },
  async accept({ commit, state }, { id, observation }) {
    await this.$axios.post(`/v3/app/annualfeedback/${id}/accept`, {
      observation,
    })
    commit('UPDATE_ROOT', {
      pendingAcceptances: state.pendingAcceptances.filter(
        item => item._id !== id
      ),
    })
  },
  async finalize({ commit, state }, { id, observation }) {
    await this.$axios.post(`/v3/app/annualfeedback/${id}/finalize`, {
      observation,
    })
    commit('UPDATE_ROOT', {
      teamPending: state.teamPending.filter(item => item._id !== id),
    })
  },
}
